(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top_category"] && !Shopify.designMode) return;
  try {
    
  
  
  
  const slider = document.getElementsByClassName('instaslider')[0];

const timeline = new TimelineLite();

const info = document.getElementsByClassName('c-drag')[0];

let canMove = false;

let touchDown = 0;

let prevX = 0;

let slides = document.getElementsByClassName('instaslide');

const slideWidth = slides[0].offsetWidth + 20;

const init = () => {

  slider.addEventListener('mousedown', handleMouse);

  slider.addEventListener('mouseup', handleMouse);

  slider.addEventListener('mousemove', handleMove);

  slider.addEventListener('touchstart', handleTouch);

  slider.addEventListener('touchmove', handleTouchMove);

};

const handleMouse = e => {

  if (e.type === 'mouseup') {

    canMove = false;

  } else {

    canMove = true;

  }

};

const handleMove = e => {

  if (e.pageX < prevX && canMove) {

    info.innerHTML = 'Swiping left!';

    handleSwipeLeft();

    canMove = false;

  } else if (e.pageX > prevX && canMove) {

    info.innerHTML = 'Swiping right!';

    handleSwipeRight();

    canMove = false;

  }

  prevX = e.pageX;

};

const handleTouch = e => {

  touchDown = e.touches[0].clientX

}

const handleTouchMove = e => {

  if (!touchDown) {

    return

  }

  const touchUp = e.touches[0].clientX

  const touchDiff = touchDown - touchUp

  if (touchDiff > 0) {

    info.innerHTML = 'Swiping left!';

    handleSwipeLeft();

  } else {

    info.innerHTML = 'Swiping right!';

    handleSwipeRight();

  }

   touchDown = null

 };

const handleSwipeLeft = () => {  

  timeline.fromTo(slider, 1, 

    {

      x: '0px'

    },

    {

      x: `-${slideWidth}px`,

      ease: Power4.easeOut

    }

  );

  timeline.to(slider, 0.001, 

    {

      x: '0px',

      onComplete: () => {

        slider.appendChild(slides[0]);

        slides = document.getElementsByClassName('instaslide');

      }

    }

  );

};

const handleSwipeRight = () => {  

  timeline.to(slider, 0.001, 

    {

      x: `-${slideWidth}px`,

      onComplete: () => {

        const first = slides[0];

        const last = slides[slides.length - 1];

        slider.insertBefore(last, first);

        slides = document.getElementsByClassName('instaslide');

      }

    }

  );

  timeline.to(slider, 1, 

    {

      x: `0px`,

      ease: Power4.easeOut

    }

  );

};

init();

  } catch(e) { console.error(e); }
})();
})();
